import Item from 'owa-service/lib/contract/Item';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SharingAcceptButton from '../components/SharingAcceptButton';

export default function addInteractiveElementsForReadingPane(element: HTMLElement, item: Item) {
    const button = <SharingAcceptButton item={item} />;
    ReactDOM.render(button, element, null /* callback */);
    element.className = ''; // overwrite the server's OLK-hidden class
}
